import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../lib/api";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";

// Download the signed-in user's own temple Android app (served only to that temple's staff).
// Hidden inside the Android app itself, where there is nothing to download.
export default function DownloadAppButton({ className = "", dark = false }) {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const inApp = /; wv\)/.test(navigator.userAgent);

  useEffect(() => {
    if (inApp) return;
    api.get("/apps/info").then((r) => setInfo(Array.isArray(r.data) ? null : r.data)).catch(() => {});
  }, [inApp]);

  if (inApp || !info?.size) return null;

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/apps/download", { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/vnd.android.package-archive" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `Darshan_${info.temple_id}.apk`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
      toast.success("Download started — open the file to install the app");
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={download} disabled={busy} data-testid="download-temple-app"
      className={`inline-flex items-center justify-center gap-2 rounded-xl text-sm font-semibold transition ${dark
        ? "bg-white/15 border border-white/40 text-white hover:bg-white/25" : "bg-white border border-[#E5D9C5] text-maroon-800 hover:bg-gold-50"} ${className}`}>
      <Smartphone className="w-4 h-4" /> {busy ? "Downloading…" : `Download Android App${info.version ? ` · v${info.version.split(" ")[0]}` : ""}`}
    </button>
  );
}
